import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const BookingModule = new Module<Types.BookingFragment, Types.GetBookingsQueryVariables, Types.Bookings_Insert_Input>({
    orderBy: {
        'created_at': 'desc'
    }
})